jQuery( function ( $ ) {
    //スマホ表示時の折りたたみ
    $( '.js-refineModal__label' ).on( 'click', function() {
        if ( window.matchMedia( "(max-width: 599.9999px)" ).matches) {
            $( this ).toggleClass( 'is-active' ).next( '.js-refineModal__options' ).slideToggle();
        }
    } );

    //PC時の折りたたみ
    $( '.js-refineModal__fold' ).on( 'click', function() {
        if ( $( this ).hasClass( 'is-folded' ) ) {
            $( this ).removeClass( 'is-folded' );
            $( '.js-refineModal__contents' ).slideDown();
            $( this ).children('span').html('閉じる');
        } else {
            $( this ).addClass( 'is-folded' );
            $( '.js-refineModal__contents' ).slideUp();
            $( this ).children('span').html('開く');
        }
    } );

    //再選択
    $( '.js-change-area' ).on( 'click', function() {
        $( this ).attr( 'disabled', true );
        $( '.js-refineModal' ).slideDown();
    } );

    $( '.js-refineModal__close' ).on( 'click', function() {
        $( '.js-change-area' ).attr( 'disabled', false );
        $( '.js-refineModal' ).slideUp();
    } );


    //リサイズ時にすべて解除
    $( window ).on( 'resize', function() {
        let flag = '';
        if ( window.matchMedia( "(min-width: 600px)" ).matches && flag != 'pc') {
            flag = 'pc';
            $( '.js-refineModal__label' ).removeClass( 'is-active' );
            $( '.js-refineModal__options' ).removeAttr( 'style' );
            $( '.js-refineModal__contents' ).removeAttr( 'style' );
        } else if ( window.matchMedia( "(max-width: 599px)" ).matches && flag != 'sp') {
            flag = 'sp';
            $( '.js-refineModal__label' ).removeClass( 'is-active' );
            $( '.js-refineModal__options' ).removeAttr( 'style' );            
        }
    } );
} );